import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useLanguage } from '@/contexts/AppContext';
import type { CookingTimeModalProps, Day } from './types';
import { translations, cookingTimeData, getCurrentDay } from './constants';
import { DaySection } from './DaySection';
import { StatusGuide } from './StatusGuide';

export function CookingTimeModal({ isOpen, onClose, storeName }: CookingTimeModalProps) {
  // #522: 15 locale 전수 지원 — locale 로 lookup
  const { locale } = useLanguage();
  const t = translations[locale];
  const currentDay = getCurrentDay();
  const days: Day[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[calc(100vw-2rem)] w-full max-h-[85vh] overflow-y-auto bg-background rounded-[clamp(12px,3vw,20px)] p-0">
        <DialogHeader className="relative p-6 pb-4 bg-gradient-to-br from-background to-muted/50 rounded-t-2xl border-b border-border/30">
          <div className="relative">
            <div className="flex flex-col gap-2">
              <DialogTitle className="text-xl text-foreground">
                {t.title}
              </DialogTitle>

              <p className="text-sm text-muted-foreground">
                {storeName}
              </p>

              <p className="text-sm text-foreground">
                {t.subtitle}
              </p>
            </div>

            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-primary/5 to-transparent rounded-full -translate-y-4 translate-x-4" />
            <div className="absolute bottom-0 left-20 w-16 h-16 bg-gradient-to-tr from-secondary/5 to-transparent rounded-full translate-y-2" />
          </div>
        </DialogHeader>

        <div className="p-[clamp(16px,4vw,24px)] space-y-[clamp(16px,4vw,20px)]">
          {days.map((day) => (
            <DaySection
              key={day}
              day={day}
              dayData={cookingTimeData[day]}
              isCurrentDay={day === currentDay}
              t={t}
            />
          ))}
        </div>

        <StatusGuide t={t} />
      </DialogContent>
    </Dialog>
  );
}
